;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { EyeIcon, EyeSlashIcon } from '@heroicons/react/20/solid'
import * as React from 'react'
import {
  ComponentPropsWithoutRef,
  createContext,
  HTMLAttributes,
  useContext,
  useState,
} from 'react'

import { cn } from '../../utils/cn'
import { BaseButton } from './base-button'
import { Input } from './input'

type PasswordFieldContext = {
  type: 'text' | 'password'
}

const PasswordFieldContext = createContext<PasswordFieldContext | undefined>(
  undefined,
)

function usePasswordFieldContext() {
  const context = useContext(PasswordFieldContext)
  if (!context) {
    throw new Error(
      'usePasswordFieldContext must be used within a PasswordField',
    )
  }
  return context
}

/**
 * A wrapper for password fields that provides a button to toggle visibility
 */
function PasswordFieldRoot({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false)

  return (
    <PasswordFieldContext.Provider
      value={{ type: isPasswordVisible ? 'text' : 'password' }}
    >
      <div className={cn('group relative', className)} {...props}>
        {children}
        <span className="absolute top-0 right-0 bottom-0 grid place-content-center pr-3">
          <BaseButton
            aria-label={isPasswordVisible ? 'Hide password' : 'Show password'}
            onClick={() => setIsPasswordVisible(!isPasswordVisible)}
            className="rounded-sm text-gray-400 hover:text-gray-600"
          >
            <EyeIcon
              className={cn('h-5 w-5', isPasswordVisible ? 'hidden' : 'block')}
            />
            <EyeSlashIcon
              className={cn('h-5 w-5', isPasswordVisible ? 'block' : 'hidden')}
            />
          </BaseButton>
        </span>
      </div>
    </PasswordFieldContext.Provider>
  )
}

/**
 * An input field for passwords
 *
 * Consumes context from `<PasswordFieldRoot>` to determine whether the input should be
 * visible (type="text") or hidden (type="password")
 */
function PasswordFieldInput({
  className,
  ...props
}: Omit<ComponentPropsWithoutRef<typeof Input>, 'type'>) {
  const { type } = usePasswordFieldContext()
  return (
    <Input className={cn('w-full pr-11', className)} {...props} type={type} />
  )
}

export { PasswordFieldInput, PasswordFieldRoot }
